var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 15A15.02 15.02 0 0 1 15 0a14.86 14.86 0 0 1 9.143 3.108l-3.486 4.528A9.2 9.2 0 0 0 15 5.714 9.3 9.3 0 0 0 5.714 15 9.3 9.3 0 0 0 15 24.286c4.124 0 7.628-2.702 8.836-6.429H15v-5.714h15V15a15.02 15.02 0 0 1-15 15A15.02 15.02 0 0 1 0 15"
  })));
};
export default SvgGmail;